/**
 * Check if skip authentication is allowed based on environment
 * Skip auth is enabled for demo.optimoteams.com (no environment restriction)
 */
export const isSkipAuthAllowed = (): boolean => {
    return true
}
